import React, { createContext, useMemo, useState, useContext } from "react";

interface ShiftFocusContextProps {
    isClicked: boolean;
    setIsClicked: React.Dispatch<React.SetStateAction<boolean>>;
}

const ShiftFocus = createContext<ShiftFocusContextProps | undefined>(undefined);

export const ShiftFocusProvider: React.FC = ({ children }) => {
    const [isClicked, setIsClicked] = useState(false);

    const value = useMemo(
        () => ({ isClicked, setIsClicked }),
        [isClicked, setIsClicked]
    );

    return <ShiftFocus.Provider value={value}>{children}</ShiftFocus.Provider>;
};

export const useShiftFocus = (): ShiftFocusContextProps => {
    const context = useContext(ShiftFocus);
    if (!context) {
        throw new Error(
            "useShiftFocus must be used within a ShiftFocusProvider"
        );
    }
    return context;
};
